<template>
  <div class="couponList">
    <div class="contentRight2">
      <div class="contentTabs">
        <div class="rightHead">
          <div
            style="margin:0 0 0 30px;font-size:15px;padding-top:5px;color:#707070;"
            v-if="$route.meta.titleShow"
          >
            {{ $route.name }}
          </div>
          <div class="invoicingHead" style="height: 40px">
            <el-breadcrumb
              class="elArrowText"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="coupon-content">
          <div class="row searchBox">
            <div class="activity-name">优惠券名称</div>
            <el-input
              clearable
              placeholder="请输入优惠券名称"
              v-model="keywords"
              style="width: 250px"
              class="pr30"
            ></el-input>
            <el-select
              v-model="value"
              placeholder="请选择"
              class="pr30"
              @change="statusChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button type="primary" @click="search" size="small"
              >搜索</el-button
            >
            <el-button
              type="success"
              @click="addCouponDialogVisible = true"
              size="small"
              >添加优惠券</el-button
            >
          </div>
          <div class="row" style="padding-top:30px;box-sizing:border-box;">
            <div class="pr30">营销统计</div>
            <div class="pr30 bold">
              已使用： <span class="colorblue">{{ usedCount }}</span> 张
            </div>
            <div class="pr30 bold">
              合计： <span class="color-orange">{{ deductionAmount }}</span> 元
            </div>
            <div class="colorblue" @click="lookMore">查看更多</div>
          </div>
          <div style="padding-top:30px;box-sizing:border-box;">
            <el-table
              :data="tableData"
              style="width: 100%"
              :max-height="550"
              v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.3)"
              element-loading-text="数据正在加载中"
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column
                align="center"
                prop="title"
                label="优惠券名称"
              ></el-table-column>
              <el-table-column align="center" prop="price" label="优惠券金额">
                <template slot-scope="scope"
                  >满{{ scope.row.minUsePrice }}减{{
                    scope.row.price
                  }}</template
                >
              </el-table-column>
              <el-table-column
                align="center"
                prop="overCount"
                label="剩余/总数"
              >
                <template slot-scope="scope"
                  >{{ scope.row.overCount }}/{{
                    scope.row.totalCount
                  }}</template
                >
              </el-table-column>
              <el-table-column
                align="center"
                prop="expireDay"
                label="有效期"
                width="220px"
              />
              <el-table-column
                align="center"
                prop="orderType"
                label="优惠券类型"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.orderType == 0
                        ? "普通优惠券"
                        : scope.row.orderType == 1
                        ? "套红包抵用券"
                        : scope.row.orderType == 2
                        ? "联盟优惠券"
                        : scope.row.orderType == 10
                        ? "支付宝API代金券"
                        : scope.row.orderType == 11
                        ? "支付宝代运营代金券"
                        : scope.row.orderType == 20
                        ? "微信API代金券"
                        : scope.row.orderType == 21
                        ? "微信代运营代金券"
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderStatus"
                label="审核状态"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.orderStatus == 1
                        ? "未使用"
                        : scope.row.orderStatus == 2
                        ? "已发布"
                        : scope.row.orderStatus == 3
                        ? "已用完"
                        : scope.row.orderStatus == 4
                        ? "商家停止发放"
                        : scope.row.orderStatus == 100
                        ? "审核中"
                        : scope.row.orderStatus == 101
                        ? "审核失败"
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="orderMark"
                label="审核内容"
              ></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="offCashCouponUsedDetail(scope.row)"
                    v-if="scope.row.orderStatus == 2"
                    >停用</el-button
                  >
                  <el-button type="text" @click="lookSingleDetail(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    type="text"
                    @click="resetSubmit(scope.row)"
                    v-if="
                      (scope.row.orderType == 11 ||
                        scope.row.orderType == 21) &&
                        scope.row.orderStatus == 101
                    "
                    >重新提交</el-button
                  >
                  <el-button type="text" @click="deleteCashCoupon(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div
              v-if="tableData.length > 0"
              class="block"
              style="float:right;margin-top:10px;"
            >
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNumber"
                :page-size="queryInfo.row"
                layout="total, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
        <!-- 添加优惠券 -->
        <el-dialog
          title="添加优惠券"
          :visible.sync="addCouponDialogVisible"
          width="30%"
        >
          <span>
            <el-form
              :model="addCouponForm"
              :rules="addCouponRules"
              ref="addCouponForm"
              label-width="130px"
              class="demo-ruleForm"
            >
              <el-form-item label="券类型">
                <el-select v-model="conpouValue" placeholder="请选择">
                  <el-option
                    v-for="item in conpouList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="活动名称" prop="title">
                <el-input v-model="addCouponForm.title"></el-input>
              </el-form-item>
              <el-form-item label="消费满" prop="minUsePrice">
                <el-input
                  v-model="addCouponForm.minUsePrice"
                  style="width:150px"
                ></el-input>
                <span style="padding: 0 8px;box-sizing:border-box;">减</span>
                <el-input
                  v-model="addCouponForm.price"
                  style="width:150px"
                ></el-input>
              </el-form-item>
              <el-form-item label="券数量" prop="totalCount">
                <el-input
                  v-model="addCouponForm.totalCount"
                  placeholder="请输入优惠券数量"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否支持折上折" prop="openDoubleDiscounts">
                <el-radio-group v-model="addCouponForm.openDoubleDiscounts">
                  <el-radio :label="1">支持</el-radio>
                  <el-radio :label="0">不支持</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="有效时间" prop="expireDay">
                <el-date-picker
                  v-model="addCouponForm.expireDay"
                  type="datetime"
                  placeholder="请选择有效时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="dateChange"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="使用须知" prop="introduce">
                <el-input
                  type="textarea"
                  placeholder="请输入需要备注的内容~"
                  v-model="addCouponForm.introduce"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="cardCoupon-state">发券说明</div>
            <div class="tips">{{ tips }}</div>
            <!-- <div class="tips" v-else>
                          <div>优惠券：用户领取后可在下单过程中选择自由选择卷使用，减少订单支付金额，只存在于当前系统中。</div>
                          <div>代金券：用户领取后可在支付时直接抵扣支付金额。存放在微信|支付账号内。 </div>
                          <div>注意，优惠券和代金劵如同时发放，用户领取后可同时使用。建议只发一种类型的券。</div>
                        </div> -->
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addCouponDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addPublishCashCoupon"
              >确 定</el-button
            >
          </span>
        </el-dialog>
        <!-- 查看使用详情 -->
        <el-dialog
          title="优惠券使用详情"
          :visible.sync="dialogVisible"
          width="32%"
        >
          <el-table :data="sigleTableData" style="width: 100%">
            <el-table-column prop="userPhoneNum" label></el-table-column>
            <el-table-column prop="usedTime" label></el-table-column>
            <el-table-column
              prop="operateUserName"
              label
              align="right"
            ></el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCashCouponList,
  stopCashCoupon,
  getCashCouponUsedDetail,
  addPublishCashCoupon,
  deleteCashCoupon
} from "../api/index";
export default {
  data() {
    return {
      keywords: "",
      value: "",
      options: [
        { value: "", label: "全部" },
        { value: "1", label: "正常" },
        { value: "0", label: "已停用" }
      ],
      addCouponDialogVisible: false,
      usedCount: "",
      deductionAmount: "",
      tableData: [],
      loading: false,
      queryInfo: {
        pageNumber: 1,
        row: 10
      },
      userList: {},
      status: 1,
      addCouponForm: {
        title: "",
        expireDay: "",
        minUsePrice: "",
        price: "",
        totalCount: "",
        introduce: "",
        openDoubleDiscounts: ""
      },
      addCouponRules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        expireDay: [
          { required: true, message: "请选择有效日期", trigger: "change" }
        ],
        minUsePrice: [
          { required: true, message: "请输入满减金额", trigger: "blur" }
        ],
        totalCount: [
          { required: true, message: "请输入优惠券数量", trigger: "blur" }
        ],
        introduce: [
          { required: true, message: "请输入使用规格", trigger: "blur" }
        ],
        openDoubleDiscounts: [
          { required: true, message: "请选择是否支持折上折", trigger: "change" }
        ]
      },
      conpouList: [{ value: "0", label: "普通优惠券" }],
      conpouValue: "普通优惠券",
      tips:
        "普通优惠券，发券后可在小程序（支付宝和微信），用户下单支付前根据订单金额选择使用。",
      dialogVisible: false,
      sigleTableData: []
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getCashCouponList();
  },
  methods: {
    getCashCouponList(isEnable, title) {
      this.loading = true;
      getCashCouponList({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        pageNumber: this.queryInfo.pageNumber,
        row: this.queryInfo.row,
        isEnable: isEnable,
        title: title
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.usedCount = res.data.statistics.usedCount;
          this.deductionAmount = res.data.statistics.deductionAmount.toFixed(2);
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNumber = val;
      if (this.status == 1) {
        this.getCashCouponList(this.value, this.keywords);
      } else {
        this.getCashCouponList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNumber = 1;
      this.getCashCouponList(this.value, this.keywords);
    },
    statusChange(val) {
      this.getCashCouponList(val, this.keywords);
    },
    lookMore() {
      this.$router.push("/cardCouponList");
    },
    offCashCouponUsedDetail(row) {
      this.$confirm("此操作将停用该优惠券, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(({ value }) => {
          stopCashCoupon({
            userId: this.userList.id, //用户Id
            sessionId: this.userList.sessionId,
            cashCouponBatchOrderId: row.id
          }).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getCashCouponList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    lookSingleDetail(row) {
      this.dialogVisible = true;
      getCashCouponUsedDetail({
        pageNumber: this.queryInfo.pageNo,
        cashCouponBatchOrderId: row.id,
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId
      }).then(res => {
        if (res.code == 1) {
          this.sigleTableData = res.data;
        } else if (res.code == -1) {
          this.sigleTableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deleteCashCoupon(row) {
      this.$confirm("您确定要删除该优惠券吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteCashCoupon({
            userId: this.userList.id, //用户Id
            sessionId: this.userList.sessionId,
            cashCouponBatchOrderId: row.id
          }).then(res => {
            if (res.code == 1) {
              this.getCashCouponList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    resetSubmit(row) {
      console.log(row);
      this.addCouponDialogVisible = true;
      this.addCouponForm.title = row.title;
      this.addCouponForm.minUsePrice = row.minUsePrice;
      this.addCouponForm.price = row.price;
      this.addCouponForm.totalCount = row.totalCount;
      this.addCouponForm.expireDay = row.expireDay;
      this.addCouponForm.introduce = row.introduce;
      this.addCouponForm.receiveMaxCount = row.receiveMaxCount;
      this.addCouponForm.openDoubleDiscounts = row.openDoubleDiscounts;
      if (row.orderType == 11) {
        this.tips =
          "支付宝代运营代金券发放后需要服务商审核代创建，生成后的二维码，用户可直接领取到支付宝卡包，使用支付宝时自动抵扣支付金额。";
      } else if (row.orderType == 21) {
        this.tips =
          "微信代运营代金券发放后需要服务商审核代创建，生成后的二维码，用户可直接领取到微信卡包，使用微信支付时自动抵扣支付金额。";
      }
      this.conpouValue =
        row.orderType == 0
          ? "普通优惠券"
          : row.orderType == 2
          ? "联盟优惠券"
          : row.orderType == 10
          ? "支付宝API代金券"
          : row.orderType == 11
          ? "支付宝代运营代金券"
          : row.orderType == 20
          ? "微信API代金券"
          : row.orderType == 21
          ? "微信代运营代金券"
          : "";
    },
    addPublishCashCoupon() {
      addPublishCashCoupon({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        title: this.addCouponForm.title,
        minUsePrice: this.addCouponForm.minUsePrice,
        price: this.addCouponForm.price,
        totalCount: this.addCouponForm.totalCount,
        expireDay: this.addCouponForm.expireDay,
        introduce: this.addCouponForm.introduce,
        receiveMaxCount: 5,
        openDoubleDiscounts: this.addCouponForm.openDoubleDiscounts
      }).then(res => {
        if (res.code == 1) {
          this.addCouponDialogVisible = false;
          this.getCashCouponList();
          this.queryInfo.pageNumber = 1;
          this.addCouponForm = {};
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    dateChange(date) {
      this.addCouponForm.expireDay = date;
    }
  }
};
</script>

<style lang="scss" scoped>
.couponList .el-table th {
  background: #f8f8f8;
}
.coupon-content {
  position: absolute;
  width: calc(100vw - 250px);
  top: 140px;
  padding-left: 20px;
  box-sizing: border-box;
  .searchBox {
    .activity-name {
      padding-right: 10px;
      padding-top: 6px;
      box-sizing: border-box;
    }
  }
  .row {
    .bold {
      font-weight: bold;
      .color-orange {
        color: #ff7757;
        cursor: pointer;
      }
    }
  }
}
.tips {
  width: 100%;
  height: auto;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ff9191;
  background: #ffe6e6;
  color: #ff7757;
  font-size: 12px;
}
.cardCoupon-state {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  margin-bottom: 10px;
}
.colorblue {
  color: #3388ff;
  cursor: pointer;
}
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
::v-deep .el-button {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/couponList.vue